export const AtrributeSourceIds = [1, 5, 7];
